import { defineSlotRecipe } from '@chakra-ui/react';
import { toastAnatomy } from '@chakra-ui/react/anatomy';

export default defineSlotRecipe({
  slots: toastAnatomy.keys(),
  base: {
    root: {
      borderRadius: 'md',
      m: 2,
      py: 3,
      ps: 4,
      pe: 8,
      w: 'fit',
      minW: 'xs',
      maxW: 'md',
      '&[data-type=success]': {
        bg: 'green.solid',
        color: 'green.contrast',
      },
      '&[data-type=error]': {
        bg: 'red.solid',
        color: 'red.contrast',
      },
      '&[data-type=warning]': {
        bg: 'orange.solid',
        color: 'orange.contrast',
      },
      '&[data-type=info]': {
        bg: 'blue.solid',
        color: 'blue.contrast',
      },
    },
    title: {
      fontWeight: 'bold',
      me: 2,
      lineHeight: 'tall',
    },
    description: {
      textStyle: 'sm',
      opacity: 1,
    },
    indicator: {
      w: 5,
      h: 6,
      flexShrink: 0,
    },
    closeTrigger: {
      top: '2',
      insetEnd: '2',
    },
  },
});
